module.exports = __webpack_public_path__ + "static/media/cloudy-sun.6a345f19.svg";